import React, { useEffect } from 'react'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import Loadable from '../../../components/loadable/Loadable'
import Label from '../../../components/label/Label'
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setRowsPerPage, setSelectedForm, setSelectedPayer, setSelectedTaxYear, setSkip } from './MemberUserHistorySlice'
import styles from "./MemberUserHistory.styles"
import { exportMemberUserHistoryExcel, getFormsList, getMemberUserHistory, getPayersList, getTaxYearsList } from './MemberUserHistorySaga'
import { COMMON_EXPORTING_STATES, COMMON_EXPORTING_STATES_MESSAGE_MAP, COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP } from '../../constants/constants'
import RichGrid from '../../../components/richgrid/RichGrid'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import { BUTTON_TYPE } from '../../../components/button/constants'
import Button from '../../../components/button/Button'
import General from '../../../../libs/utility/General'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'

const MemberUserHistory = () => {
    useGarbageCollector(componentKey);

    const dispatch = useDispatch()
    const { payersList, taxYearsList, formList, selectedPayer, selectedForm, selectedTaxYear, loadingState, memberUserHistory, skip, rowsPerPage, totalMemberUserHistory, exportFile } = useSelector(state => state[componentKey])

    useEffect(() => {
        dispatch(getPayersList())
        dispatch(getFormsList())
    }, [])

    useEffect(() => {
        if (selectedForm?.value) {
            dispatch(getTaxYearsList({ formId: selectedForm?.value }))
        }
    }, [selectedForm?.value])

    useEffect(() => {
        if (!selectedTaxYear.value || !selectedForm.label || !selectedPayer.value) {
            return
        }

        dispatch(getMemberUserHistory({ PageSize: rowsPerPage, PageNumber: (skip / rowsPerPage) + 1, taxYear: selectedTaxYear.value, formId: selectedForm.label, payerId: selectedPayer.value }))
    }, [rowsPerPage, skip, selectedTaxYear, selectedForm, selectedPayer])

    useEffect(() => {
        General.downloadFileWithBase64AndName(exportFile)
    }, [exportFile])

    const handleFilterChange = (name, selectedOption) => {
        switch (name) {
            case 'taxYear':
                dispatch(setSelectedTaxYear({ ...selectedOption }))
                break;
            case 'payer':
                dispatch(setSelectedPayer({ ...selectedOption }))
                break;
            case 'form':
                dispatch(setSelectedForm({ ...selectedOption }))
                break;
        }
    }

    const handleExport = ()=>{
        dispatch(exportMemberUserHistoryExcel())
    }

    const MEMBER_USER_HISTORY_COLUMNS = [
        {
            field: "formType",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Form Type</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.FormName}</span>
        },
        {
            field: "createdDate",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Created Date</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.CreatedDate}</span>
        },
        {
            field: "status",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Status</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.Status}</span>
        },
        {
            field: "reviewedBy",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Reviewed By</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.ReviewerIds}</span>
        },
        {
            field: "approvedBy",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Approved By</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.ApprovedUserID}</span>
        },
        {
            field: "updatedDate",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Updated Date</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.UpdatedDate}</span>
        },
        {
            field: "submittedForReviewBy",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Submitted For Review By</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.Member}</span>
        },
    ]
    return (
        <>
            <Heading type={HEADING.H1}>Member User History</Heading>
            <Loadable currentState={loadingState.state} loadingStates={COMMON_LOADING_STATES.FILTER_LOADING} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
               
                <div style={styles.filtersWrapper}>
                    <div style={styles.filterRow}>
                        <div>
                            <Label>Tax Year</Label>
                            <SelectDropdown
                                name="taxYear"
                                value={{ label: selectedTaxYear.label, value: selectedTaxYear.value }}
                                prefixProps={{ text: "" }}
                                onSelectCb={(name, selectedOption) => handleFilterChange(name, selectedOption)}
                                options={taxYearsList}
                                placeHolder="Select Tax Year"
                                isClearable={false}
                            />
                        </div>
                        <div>
                            
                            <Label>Form</Label>
                            <SelectDropdown
                                name="form"
                                value={{ label: selectedForm.label, value: selectedForm.value }}
                                prefixProps={{ text: "" }}
                                onSelectCb={(name, selectedOption) => handleFilterChange(name, selectedOption)}
                                options={formList}
                                placeHolder="Select Form"
                                isClearable={false}
                            />
                        </div>
                        <div>
                            <Label>Payer</Label>
                            <SelectDropdown
                                name="payer"
                                value={{ label: selectedPayer.label, value: selectedPayer.value }}
                                prefixProps={{ text: "" }}
                                onSelectCb={(name, selectedOption) => handleFilterChange(name, selectedOption)}
                                options={payersList}
                                placeHolder="Select Payer"
                                isClearable={false}
                            />
                        </div>
                    </div>
                    <div>
                        <Loadable currentState={loadingState.state} loadingStates={COMMON_EXPORTING_STATES.EXPORT_LOADING} messageMap={COMMON_EXPORTING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                            <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={handleExport}>Export to Excel</Button>
                        </Loadable>
                    </div>
                </div>

            </Loadable>
            <Loadable currentState={loadingState.state} loadingStates={COMMON_LOADING_STATES.GRID_LOADING} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                <div style={styles.grid}>
                    <RichGrid
                        data={memberUserHistory}
                        columns={MEMBER_USER_HISTORY_COLUMNS}
                        selectable={false}
                        extractRowKey={(row) => row.CreatedDate}
                        paginationProps={{
                            skip: skip,
                            take: rowsPerPage,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setRowsPerPage(newTake));
                                dispatch(setSkip(0))
                            },
                            total: totalMemberUserHistory,
                            onChange: (take, t) => {
                                dispatch(setRowsPerPage(take));
                                dispatch(setSkip(t))
                            },
                        }}
                    />
                </div>
            </Loadable>
        </>
    )
}

export default MemberUserHistory